const MenuIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27 6H1V4H27V6ZM27 15L1 15V13L27 13V15ZM1 24H27V22H1V24Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default MenuIcon
